export const getMemberPartMeta = (partsById: Map<unknown, unknown>, partId: unknown) => {
  if (!(partsById instanceof Map) || partId == null) return null;
  return partsById.get(partId) || partsById.get(String(partId)) || null;
};

export const toMemberRowOrder = (value: unknown, fallback = 9999) => {
  if (value === null || value === undefined || value === '') return fallback;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : fallback;
};

type MemberRow = {
  sortOrder?: unknown;
  isConcertmaster?: boolean;
  isChief?: boolean;
  contractTs?: number | null;
  name?: string;
};

export const compareEventMemberRows = (left: MemberRow, right: MemberRow) => {
  const leftOrder = toMemberRowOrder(left?.sortOrder);
  const rightOrder = toMemberRowOrder(right?.sortOrder);
  if (leftOrder !== rightOrder) return leftOrder - rightOrder;
  if (!!left?.isConcertmaster !== !!right?.isConcertmaster) {
    return left?.isConcertmaster ? -1 : 1;
  }
  if (!!left?.isChief !== !!right?.isChief) return left?.isChief ? -1 : 1;
  const leftContractTimestamp = left?.contractTs;
  const rightContractTimestamp = right?.contractTs;
  if (
    leftContractTimestamp != null
    && rightContractTimestamp != null
    && leftContractTimestamp !== rightContractTimestamp
  ) {
    return leftContractTimestamp - rightContractTimestamp;
  }
  if (leftContractTimestamp != null && rightContractTimestamp == null) return -1;
  if (leftContractTimestamp == null && rightContractTimestamp != null) return 1;
  return String(left?.name || '').localeCompare(String(right?.name || ''), 'ja');
};
